import React, { useEffect, useState } from 'react';
import { getEditoriales } from '../services/editorialService';
import { Link, useParams } from 'react-router-dom';

export default function EditorialesPage() {
  const [editoriales, setEditoriales] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { id } = useParams(); 

  const [selectedEditorial, setSelectedEditorial] = useState(null);

  useEffect(() => {
    const fetchEditoriales = async () => {
      try {
        const data = await getEditoriales();
        setEditoriales(data);
        // si no hay id en la URL, mostrar la primera como default
        setSelectedEditorial(data[0] || null);
      } catch (err) {
        console.error(err);
        setError('Error al cargar las editoriales');
      } finally {
        setLoading(false);
      }
    };

    fetchEditoriales();
  }, []);

  useEffect(() => {
    if (id && editoriales.length > 0) {
      const editorial = editoriales.find((e) => e.id === parseInt(id));
      setSelectedEditorial(editorial || editoriales[0]);
    }
  }, [id, editoriales]);

  if (loading) return <div className="alert alert-success">Cargando editoriales...</div>;
  if (error) return <div className="alert alert-danger">{error}</div>;

  if (!selectedEditorial) return <div>No hay editoriales para mostrar.</div>;

  return (
  <div className="container my-5">
    <div className="row g-5"> 
      
      {/* Columna principal: Editorial completa */}
      <div className="col-lg-8">
        <article>
          <h6 className="text-uppercase fw-bold mb-2" style={{ color:'#115d3d', letterSpacing: '2px' }}>
            Editorial
          </h6>
          
          <h1 className="display-4 fw-bold mb-4" style={{ color: '#434242' }}>
            {selectedEditorial.titulo}
          </h1>

          <div className="bajada-editorial mb-4">
            <p className="lead fw-normal text-muted" style={{ fontStyle: 'italic', fontSize: '1.25rem' }}>
              {selectedEditorial.bajada}
            </p>
          </div>

  
          <div className="d-flex align-items-center mb-4 py-3 border-top border-bottom">
            <p className="text-uppercase fw-semibold mb-0" style={{ letterSpacing: '1px', fontSize: '0.85rem', color: '#6c757d' }}>
              Por <span className="text-dark fw-bold">{selectedEditorial.autor}</span> | {new Date(selectedEditorial.fechaPublicacion).toLocaleDateString('es-AR', { year: 'numeric', month: 'long', day: 'numeric' })}
            </p>
          </div>


          {selectedEditorial.imagen && (
            <div className="mb-5 shadow-sm" style={{ backgroundColor: '#f1f1f1', borderRadius: '15px', overflow: 'hidden' }}>
              <img 
                src={`${process.env.REACT_APP_API_URL || 'http://localhost:5000'}${selectedEditorial.imagen}`}
                alt={selectedEditorial.titulo}
                className="img-fluid w-100"
                style={{ maxHeight: '450px', objectFit: 'contain' }}
              />
            </div>
          )}

                    {/* Sección de Redes Sociales */}
<div className="share-section border-top pt-4 mb-5">
  <p className="text-uppercase fw-bold small text-muted mb-3" style={{ letterSpacing: '1px' }}>
    Compartir esta nota:
  </p>
  <div className="d-flex gap-2">
    {/* WhatsApp */}
    <a 
      href={`https://wa.me/?text=${encodeURIComponent(selectedEditorial.titulo + " " + window.location.href)}`}
      target="_blank" rel="noopener noreferrer"
      className="btn btn-outline-dark rounded-circle"
      style={{ width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
    >
      <i className="bi bi-whatsapp"></i>
    </a>
    {/* Twitter / X */}
    <a 
      href={`https://twitter.com/intent/tweet?text=${encodeURIComponent(selectedEditorial.titulo)}&url=${encodeURIComponent(window.location.href)}`}
      target="_blank" rel="noopener noreferrer"
      className="btn btn-outline-dark rounded-circle"
      style={{ width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
    >
      <i className="bi bi-twitter-x"></i>
    </a>
    {/* LinkedIn */}
    <a 
      href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(window.location.href)}`}
      target="_blank" rel="noopener noreferrer"
      className="btn btn-outline-dark rounded-circle"
      style={{ width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
    >
      <i className="bi bi-linkedin"></i>
    </a>
 {/* Telegram */}
    <a 
  href={`https://t.me/share/url?url=${encodeURIComponent(window.location.href)}&text=${encodeURIComponent(selectedEditorial.titulo)}`}
  target="_blank" rel="noopener noreferrer"
  className="btn btn-outline-dark rounded-circle"
  style={{ 
    width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'all 0.3s ease'}}
onMouseOver={(e) => {
    e.currentTarget.style.backgroundColor = '#000';
    e.currentTarget.style.color = '#fff';
    e.currentTarget.style.transform = 'scale(1.1)';
  }}
  onMouseOut={(e) => {
    e.currentTarget.style.backgroundColor = 'transparent';
    e.currentTarget.style.color = 'currentColor';
    e.currentTarget.style.transform = 'scale(1)';
  }}
>
  <i className="bi bi-telegram"></i>
</a>
  </div>
  </div>

          {/* Cuerpo de la Editorial */}
          <div 
            className="contenido-editorial lh-lg"
            style={{ fontSize: '1.1rem', color: '#333', textAlign: 'justify' }}
            dangerouslySetInnerHTML={{ __html: selectedEditorial.contenido }}
          />
        </article>
      </div>

      {/* Columna derecha: Editoriales recientes */}
      <div className="col-lg-4">
        <aside className="sticky-top" style={{ top: '2rem' }}>
          <div className="recientes-card p-4 border-0 shadow-sm" style={{ backgroundColor: '#fdfdfd', borderRadius: '15px' }}>
            <h4 className="fw-bold mb-4 border-bottom pb-2">Más Recientes</h4>
            <div className="list-group list-group-flush">
              {editoriales.slice(0, 5).map((e) => (
                <Link 
                  key={e.id} 
                  to={`/editoriales/${e.id}`} 
                  className="list-group-item list-group-item-action border-0 px-3 py-3 mb-2"
                  style={{ 
                    borderRadius: '12px',
                    transition: 'all 0.3s ease', // Suaviza el movimiento y el color
                    backgroundColor: 'transparent'
                  }}
                  // Efectos al pasar el mouse
                  onMouseOver={(e) => {
                    e.currentTarget.style.backgroundColor = '#f1f1f1';
                    e.currentTarget.style.transform = 'translateX(8px)'; // Se desplaza un poquito a la derecha
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.backgroundColor = 'transparent';
                    e.currentTarget.style.transform = 'translateX(0)';
                  }}
                >
                  <small className="text fw-bold text-uppercase" style={{ color: '#115d3d',fontSize: '0.7rem' }}>
                    {new Date(e.fechaPublicacion).toLocaleDateString()}
                  </small>
                  <h6 className="mb-1 fw-bold d-block" style={{ lineHeight: '1.4' }}>{e.titulo}</h6>
                  <p className="small text-muted mb-0 text-truncate">{e.bajada}</p>
                </Link>
              ))}
            </div>
          </div>
        </aside>
      </div>

    </div>
  </div>
);
}